//** Define Actions */
export const GET_RESTAURANTS_LIST = "GET_RESTAURANTS_LIST";
export const SET_RESTAURANTS_LIST = "SET_RESTAURANTS_LIST";

//** Create action functions */
export const getRestaurantsList = (businessID, category) => ({
  type: GET_RESTAURANTS_LIST,
  businessID,
  category,
});

export const setRestaurantsList = (restaurantsList) => ({
  type: SET_RESTAURANTS_LIST,
  restaurantsList,
});

//** Create initial state */
const initialState = {
  restaurantsList: [],
};

//** Create the handler function */
const restaurantsReducer = (
  state = initialState,
  { type, restaurant, restaurantsList },
) => {
  switch (type) {
    case SET_RESTAURANTS_LIST:
      return {
        ...state,
        restaurantsList: restaurantsList.map((restaurant) => {
          return {
            ...restaurant,
            key: restaurant.id,
          };
        }),
      };
    default:
      return state;
  }
};

export default restaurantsReducer;
